import React, { useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Common from "../../component/Common.js";
import { get } from "../../lib/comm.js";
import {
  MainContext,
  STATUS_ONLINE,
  UIContext,
  UpdateContext,
} from "../../main-context.js";
import Spinner from "../helpers/Spinner.js";

export default function Admin() {
  const update_context = useContext(UpdateContext);
  const main_context = useContext(MainContext);
  const history = useHistory();
  useEffect(() => {
    async function call_api() {
      const admins = await get(
        "/api/home",
        null,
        main_context.status.id,
        update_context,
        history
      );
      if (admins === "comm error") return;

      const fmcRate = await get(
        "/api/home/fmc",
        null,
        main_context.status.id,
        update_context,
        history
      );
      if (admins === "comm error") return;

      const flash_audit_status = await get(
        "/api/flash-audit/status",
        null,
        main_context.status.id,
        update_context,
        history
      );
      if (flash_audit_status === "comm error") return;

      const fso_status = await get(
        "/api/inspections/fso/status",
        null,
        main_context.status.id,
        update_context,
        history
      );
      if (fso_status === "comm error") return;

      update_context.update_main_context((prev) => ({
        ...prev,
        fso_status: {
          pending: fso_status.pending,
          equipmentId: fso_status.equipmentId,
        },
        admins: {
          tasksRemaining: admins.tasksRemaining,
          openItemsCount: admins.openItemsCount,
          outOfServiceCount: admins.outOfServiceCount,
          leader: admins.leader,
          isfuelfarm: admins.isfuelfarm,
          fmcRate: fmcRate.fmcRate,
        },
        flash_audit_status: {
          active_flash_audits: flash_audit_status.activeFlashAudits,
          pending_items: flash_audit_status.pendingItems,
        },
      }));
    }
    call_api();
  }, [history, main_context.status.id, update_context]);
  return (
    <UIContext.Consumer>
      {({ online_status }) => (
        <MainContext.Consumer>
          {({ admins, flash_audit_status, fso_status }) => (
            <div>
              <Common></Common>
              <div className="col-xs-12 col-sm-8">
                <div className={"home-commands"}>
                  <div className="row">
                    <div className="col-xs-12">
                      <p>
                        {!!flash_audit_status.active_flash_audits && (
                          <Link
                            to={update_context.settings.subfolder + "/fa/index"}
                            className="btn btn-danger btn-block"
                          >
                            Active Flash Audits:
                            <strong>
                              {flash_audit_status.active_flash_audits}
                            </strong>
                            <br />
                            Pending Items:
                            <strong>{flash_audit_status.pending_items}</strong>
                          </Link>
                        )}
                      </p>
                      <p>
                        {fso_status.pending && (
                          <Link
                            to={
                              update_context.settings.subfolder +
                              "/fso/preview/" +
                              fso_status.equipmentId
                            }
                            className="btn btn-danger btn-block"
                          >
                            FSO Pending
                          </Link>
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6">
                      <p>
                        <Link
                          to={
                            update_context.settings.subfolder +
                            "/inspections/daily"
                          }
                          className="btn btn-block btn-default btn-lg"
                        >
                          Daily Inspections
                        </Link>
                      </p>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <p>
                        <Link
                          to={
                            update_context.settings.subfolder +
                            "/inspections/weekly"
                          }
                          className="btn btn-block btn-default btn-lg"
                        >
                          Weekly Inspections
                        </Link>
                      </p>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <p>
                        {(online_status === STATUS_ONLINE && (
                          <Link
                            to={
                              update_context.settings.subfolder +
                              "/online-only/users/leaderboard"
                            }
                            className="btn btn-block btn-default btn-lg"
                          >
                            Leaderboard
                          </Link>
                        )) || (
                          <span
                            className="btn btn-block btn-default btn-lg"
                            style={{
                              backgroundColor: "#eaeaea",
                            }}
                          >
                            Leaderboard
                          </span>
                        )}
                      </p>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <p>
                        <Link
                          to={
                            update_context.settings.subfolder +
                            "/inspections/maintenance"
                          }
                          className="btn btn-block btn-default btn-lg"
                        >
                          Maintenance Dashboard
                        </Link>
                      </p>
                    </div>

                    <div className="col-xs-12 col-sm-6">
                      {(online_status === STATUS_ONLINE && (
                        <p>
                          <Link
                            to={
                              update_context.settings.subfolder +
                              "/online-only/maintenance"
                            }
                            className="btn btn-block btn-default btn-lg"
                          >
                            Discrepancy Log
                          </Link>
                        </p>
                      )) || (
                        <p>
                          <span
                            className="btn btn-block btn-default btn-lg"
                            style={{
                              backgroundColor: "#eaeaea",
                            }}
                          >
                            Discrepancy Log
                          </span>
                        </p>
                      )}
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <p>
                        {(online_status === STATUS_ONLINE && (
                          <Link
                            to={
                              update_context.settings.subfolder +
                              "/online-only/users"
                            }
                            className="btn btn-block btn-default btn-lg"
                          >
                            User Management
                          </Link>
                        )) || (
                          <span
                            className="btn btn-block btn-default btn-lg"
                            style={{
                              backgroundColor: "#eaeaea",
                            }}
                          >
                            User Management
                          </span>
                        )}
                      </p>
                    </div>

                    <div className="col-xs-12 col-sm-6">
                      <p>
                        {(online_status === STATUS_ONLINE && (
                          <Link
                            to={
                              update_context.settings.subfolder +
                              "/online-only/equipment"
                            }
                            className="btn btn-block btn-default btn-lg"
                          >
                            Equipment
                          </Link>
                        )) || (
                          <span
                            className="btn btn-block btn-default btn-lg"
                            style={{
                              backgroundColor: "#eaeaea",
                            }}
                          >
                            Equipment
                          </span>
                        )}
                      </p>
                    </div>

                    <div className="col-xs-12 col-sm-6">
                      <p>
                        {(online_status === STATUS_ONLINE && (
                          <Link
                            to={
                              update_context.settings.subfolder +
                              "/online-only/signatureRoster/signatureRoster"
                            }
                            className="btn btn-block btn-default btn-lg"
                          >
                            Signature Roster
                          </Link>
                        )) || (
                          <span
                            className="btn btn-block btn-default btn-lg"
                            style={{
                              backgroundColor: "#eaeaea",
                            }}
                          >
                            Signature Roster
                          </span>
                        )}
                      </p>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <p>
                        {(online_status === STATUS_ONLINE && (
                          <Link
                            to={
                              update_context.settings.subfolder +
                              "/online-only/flash-audit"
                            }
                            className="btn btn-block btn-default btn-lg"
                          >
                            Flash Audit
                          </Link>
                        )) || (
                          <span
                            className="btn btn-block btn-default btn-lg"
                            style={{
                              backgroundColor: "#eaeaea",
                            }}
                          >
                            Flash Audit
                          </span>
                        )}
                      </p>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <p>
                        <Link
                          to={
                            update_context.settings.subfolder +
                            "/inspections/fso"
                          }
                          className="btn btn-block btn-default btn-lg"
                        >
                          Safety Observations
                        </Link>
                      </p>
                    </div>
                    {admins && admins.isfuelfarm && (
                      <div className="col-xs-12 col-sm-6">
                        <p>
                          {(online_status === STATUS_ONLINE && (
                            <Link
                              to={
                                update_context.settings.subfolder +
                                "/online-only/inventory"
                              }
                              className="btn btn-block btn-default btn-lg"
                            >
                              Inventory
                            </Link>
                          )) || (
                            <span
                              className="btn btn-block btn-default btn-lg"
                              style={{
                                backgroundColor: "#eaeaea",
                              }}
                            >
                              Inventory
                            </span>
                          )}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4 text-center">
                <h3>FMC Rate</h3>
                <h2>
                  <strong>
                    <Spinner
                      waitfor={admins && admins.fmcRate != null}
                      className="spin-loader"
                    >
                      {admins ? admins.fmcRate : ""}
                    </Spinner>
                  </strong>
                </h2>
                <h3>Open Items</h3>
                <h2>
                  <strong>
                    {" "}
                    <Spinner
                      waitfor={admins && admins.openItemsCount != null}
                      className="spin-loader"
                    >
                      {admins ? admins.openItemsCount : ""}
                    </Spinner>
                  </strong>
                </h2>
                <h3>Out of Service Equipment</h3>
                <h2>
                  <strong>
                    {" "}
                    <Spinner
                      waitfor={admins && admins.outOfServiceCount != null}
                      className="spin-loader"
                    >
                      {admins ? admins.outOfServiceCount : ""}
                    </Spinner>
                  </strong>
                </h2>
                <h3>Top Inspector</h3>
                <h2>
                  <strong>
                    {" "}
                    <Spinner
                      waitfor={admins && admins.leader != null}
                      className="spin-loader"
                    >
                      {admins ? admins.leader : ""}
                    </Spinner>
                  </strong>
                </h2>
                <h3>Non-Compliance Inspection Count</h3>
                <h2>
                  <strong>
                    {" "}
                    <Spinner
                      waitfor={admins && admins.tasksRemaining != null}
                      className="spin-loader"
                    >
                      {admins ? admins.tasksRemaining : ""}
                    </Spinner>
                  </strong>
                </h2>
              </div>
            </div>
          )}
        </MainContext.Consumer>
      )}
    </UIContext.Consumer>
  );
}
